/* hl-cart-minus-remove — in the cart, "−" at quantity 1 removes the line.
 *
 * Owner, 2026-09-25: "khi quantity = 1 mà bấm − thì cũng sẽ coi như là bấm delete".
 * The theme disables the minus button at the input's min (1), and a disabled
 * button never receives a click, so the button is kept enabled at 1 and the
 * press is handed to the row's own trash button (.cart-items__remove), which
 * runs the theme's onLineItemRemove — same animation, same section re-render,
 * same events as tapping the bin.
 *
 * Scope: cart line items only (.cart-items__quantity). The product page's
 * stepper is untouched. A line the platform marks as not removable (its remove
 * button is `hidden`) or not updatable (plus is disabled too) keeps the theme's
 * behaviour. The theme's delegated handlers listen on document in the bubble
 * phase, so this capture-phase listener stops the decrease.
 */
(function () {
  var ROW = '.cart-items__quantity';

  function removeBtn(minus) {
    var row = minus.closest('tr, .cart-items__table-row, .cart-item') || minus.closest(ROW);
    var b = row && row.querySelector('.cart-items__remove');
    return b && !b.hidden ? b : null;
  }
  function qty(minus) {
    var sel = minus.closest('quantity-selector-component, cart-quantity-selector-component, .quantity-selector');
    var input = sel && sel.querySelector('input');
    return input ? parseInt(input.value, 10) : NaN;
  }
  function arm(minus) {
    if (!minus.closest(ROW)) return;
    var plus = minus.parentNode && minus.parentNode.querySelector('button[name="plus"]');
    var locked = plus && plus.disabled && minus.disabled;      // can_update_quantity == false
    if (qty(minus) <= 1 && removeBtn(minus) && !locked) {
      if (minus.disabled) minus.disabled = false;
      if (minus.getAttribute('data-hl-rm') !== '1') minus.setAttribute('data-hl-rm', '1');
    } else if (minus.hasAttribute('data-hl-rm')) {
      minus.removeAttribute('data-hl-rm');
    }
  }
  function scan() { document.querySelectorAll(ROW + ' button[name="minus"]').forEach(arm); }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest && e.target.closest(ROW + ' button[name="minus"]');
    /* Decide from the flag arm() set BEFORE this press, never from the input's
       value now: another capture-phase listener on this theme decrements the
       input synchronously before this one runs (measured: a press at 2 read 1
       here), and trusting the live value removed a line the shopper only meant
       to take from 2 to 1. */
    if (!minus || minus.getAttribute('data-hl-rm') !== '1') return;
    var rm = removeBtn(minus);
    if (!rm) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    rm.click();
  }, true);

  var pending = 0;
  new MutationObserver(function () {
    if (pending) return;
    pending = requestAnimationFrame(function () { pending = 0; scan(); });
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'value'] });
  document.addEventListener('input', scan, true);
  scan();
})();
